export const Limit = Object.freeze({
	RelationList: 10,
	Results: 3,
});
